import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { DateTime } from 'luxon';
import { ChancenwerkUser } from '../../master-data-management/users/entities/ChancenwerkUser.js';
import { Student } from '../../master-data-management/users/entities/Student.js';

export enum StudentContactNoteMethod {
  EMAIL = 'E-Mail',
  SMS = 'SMS',
  WHATSAPP = 'Whatsapp',
  TELEPHONE = 'Telefon',
}

/**
 * @class StudentContactNote
 *
 * @description This class represents a note that was created by a user when contacting a student.
 */
@Entity()
export class StudentContactNote extends MongoEntity {
  public static override _class = 'StudentContactNote';
  public static override _collectionName = 'student_contact_notes';

  @validate(nonOptional())
  @Field(() => String)
  method: Maybe<StudentContactNoteMethod>;

  @DataLoadedField(() => Student, ({ studentID }) => studentID)
  student: Maybe<Student>;

  @validate(nonOptional())
  @Field(() => String)
  studentID: Maybe<string>;

  @DataLoadedField(() => ChancenwerkUser, ({ contactUserID }) => contactUserID)
  contactUser: Maybe<ChancenwerkUser>;

  @validate(nonOptional())
  @Field(() => String)
  contactUserID: Maybe<string>;

  @validate(nonOptional())
  @Field(() => String)
  contactPersonType: Maybe<string>;

  @validate(nonOptional())
  @Field(() => String)
  note: Maybe<string>;

  @validate(nonOptional())
  @Field(() => DateTime)
  date: Maybe<DateTime>;
}

if (A.isServer) {
  const attendanceEventLogs = getRawCollection<any>(StudentContactNote._collectionName);

  // Create DB Indices
  void attendanceEventLogs.then(async db => {
    void db.createIndex({ studentID: 1 });
  });
}
